import {
    GET_QF_DASHBOARD_STATS_V4_STATES,
    GET_QF_DASHBOARD_STATS_V4_STATES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_STATES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_SOURCES,
    GET_QF_DASHBOARD_STATS_V4_SOURCES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_SOURCES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_CREATIVES,
    GET_QF_DASHBOARD_STATS_V4_CREATIVES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_CREATIVES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES,
    GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_OVERVIEW,
    GET_QF_DASHBOARD_STATS_V4_OVERVIEW_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_OVERVIEW_ERROR,
} from "./actionTypes";

const initialState = {
    // Stats data by breakdown type (general for all products)
    state_stats: [],
    source_stats: [],
    creative_stats: [],
    insurance_type_stats: [],

    // Overview Stats: totals + graphs for current + optional prev
    overview_total_stats: null,
    overview_graph_stats: [],
    overview_prev_total_stats: null,
    overview_prev_graph_stats: [],

    // Loading indicators
    loading: {
        states: false,
        sources: false,
        creatives: false,
        insurance_types: false,
        overview: false,
    },

    // Error messages
    error: {
        states: null,
        sources: null,
        creatives: null,
        insurance_types: null,
        overview: null,
    },
};

const dashboardV4Reducer = (state = initialState, action) => {
    switch (action.type) {
        // States
        case GET_QF_DASHBOARD_STATS_V4_STATES:
            return {
                ...state,
                state_stats: [],
                loading: { ...state.loading, states: true },
                error: { ...state.error, states: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_STATES_SUCCESS:
            return {
                ...state,
                state_stats: action.payload?.data || [],
                loading: { ...state.loading, states: false },
                error: { ...state.error, states: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_STATES_ERROR:
            return {
                ...state,
                state_stats: [],
                loading: { ...state.loading, states: false },
                error: { ...state.error, states: action.payload },
            };

        // Sources
        case GET_QF_DASHBOARD_STATS_V4_SOURCES:
            return {
                ...state,
                source_stats: [],
                loading: { ...state.loading, sources: true },
                error: { ...state.error, sources: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_SOURCES_SUCCESS:
            return {
                ...state,
                source_stats: action.payload?.data || [],
                loading: { ...state.loading, sources: false },
                error: { ...state.error, sources: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_SOURCES_ERROR:
            return {
                ...state,
                source_stats: [],
                loading: { ...state.loading, sources: false },
                error: { ...state.error, sources: action.payload },
            };

        // Creatives
        case GET_QF_DASHBOARD_STATS_V4_CREATIVES:
            return {
                ...state,
                creative_stats: [],
                loading: { ...state.loading, creatives: true },
                error: { ...state.error, creatives: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_CREATIVES_SUCCESS:
            return {
                ...state,
                creative_stats: action.payload?.data || [],
                loading: { ...state.loading, creatives: false },
                error: { ...state.error, creatives: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_CREATIVES_ERROR:
            return {
                ...state,
                creative_stats: [],
                loading: { ...state.loading, creatives: false },
                error: { ...state.error, creatives: action.payload },
            };

        // Insurance Types
        case GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES:
            return {
                ...state,
                insurance_type_stats: [],
                loading: { ...state.loading, insurance_types: true },
                error: { ...state.error, insurance_types: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_SUCCESS:
            return {
                ...state,
                insurance_type_stats: action.payload?.data || [],
                loading: { ...state.loading, insurance_types: false },
                error: { ...state.error, insurance_types: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_ERROR:
            return {
                ...state,
                insurance_type_stats: [],
                loading: { ...state.loading, insurance_types: false },
                error: { ...state.error, insurance_types: action.payload },
            };

        // Overview
        case GET_QF_DASHBOARD_STATS_V4_OVERVIEW:
            return {
                ...state,
                overview_total_stats: null,
                overview_graph_stats: [],
                overview_prev_total_stats: null,
                overview_prev_graph_stats: [],
                loading: { ...state.loading, overview: true },
                error: { ...state.error, overview: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_OVERVIEW_SUCCESS:
            return {
                ...state,
                overview_total_stats: action.payload?.overview_total_stats || null,
                overview_graph_stats: action.payload?.overview_graph_stats || [],
                overview_prev_total_stats: action.payload?.overview_prev_total_stats || null,
                overview_prev_graph_stats: action.payload?.overview_prev_graph_stats || [],
                loading: { ...state.loading, overview: false },
                error: { ...state.error, overview: null },
            };

        case GET_QF_DASHBOARD_STATS_V4_OVERVIEW_ERROR:
            return {
                ...state,
                overview_total_stats: null,
                overview_graph_stats: [],
                overview_prev_total_stats: null,
                overview_prev_graph_stats: [],
                loading: { ...state.loading, overview: false },
                error: { ...state.error, overview: action.payload },
            };
        default:
            return state;
    }
};

export default dashboardV4Reducer;
